// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"Dialog_Dialog__3SVHG","Dialog__Open":"Dialog_Dialog__Open__Vgl3f","Dialog__Header":"Dialog_Dialog__Header__3DA8e"};